import { API_HOST } from 'lib'
import { authenticatedFetch, extractErrorMessage } from 'lib/authenticatedGet'

export type ManualActionType = 'RESTORE_OVERRIDES'

export type ManualActionInboxEntry = {
  id: string
  installationId: string
  serialNumber: string
  countryCode: string
  createdAt: string
  type: ManualActionType
  reason: string
}

export type RestoreOverridesResult = {
  inboxEntryId: string
  installationId: string
  previousInstallationId: string
  restoredModificationSets: number
  restoredModifications: number
}

export const resolveManualAction = async (id: string): Promise<RestoreOverridesResult> => {
  return authenticatedFetch<{ data: RestoreOverridesResult }>(`${API_HOST}/v1/manual-actions/${id}/resolve`, {
    method: 'POST',
  })
    .then((response) => response.data)
    .catch(extractErrorMessage)
}

export const dismissManualAction = async (id: string): Promise<void> => {
  await authenticatedFetch(`${API_HOST}/v1/manual-actions/${id}`, {
    method: 'DELETE',
  }).catch(extractErrorMessage)
}
